export default __webpack_public_path__ + "static/media/49.e592924b.png";